import React from 'react';

import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import { LanguageService } from 'services/language-service';
import { USED_LANGUAGES } from 'shared/constants/languages';

export const LanguageRouteGuard = ({ children }: { children: unknown }) => {
  const location = useLocation();
  const { locale } = queryString.parse(location.search);

  typeof locale === 'string' &&
    locale.trim() !== '' &&
    USED_LANGUAGES.includes(locale) &&
    LanguageService.changeLanguage(locale);

  return <>{children}</>;
};
